import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'

class FunctionFields {


  start_import_inventory(props_obj){
    console.dir(props_obj);
    const url = settings.API_BASE_URL + 'start_import_inventory/' + '?token=' + props_obj.auth_obj.token + '&name='+ props_obj.auth_obj.name ;
    console.log(url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    console.dir(response_obj);
    return response_obj.result;

  }




  getTonyaList(auth_obj, type, props_obj){
    console.log('getTonyaList');
    
    let todayDate = new Date();
		let _toObj = new Date(todayDate.setDate(todayDate.getDate() + 1));
    let _to = _toObj.getFullYear() + '-' + (_toObj.getMonth()+1) + '-' + _toObj.getDate() ;
		let _fromObj = new Date(todayDate.setDate(todayDate.getDate() - props_obj.data._from));
		let _from = _fromObj.getFullYear() + '-' + (_fromObj.getMonth()+1) + '-' + _fromObj.getDate() ;

    const url = settings.API_BASE_URL + 'tonya_info/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name + '&type='+type+'&_from='+_from+'&_to='+_to;
    console.log(url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    console.dir(response_obj);

    if(response_obj===undefined){
      const cookies = Cookies.get();
      for (const cookieName in cookies) {
        Cookies.remove(cookieName);
      }
      window.location.href = settings.API_BASE_URL+'login';
    }

    return response_obj.tonya_info;

    //const response = await fetch(url);
    //const json = await response.json();
    //console.dir(json.tonya_info)
    //return json.tonya_info;

  }

  checkWhenUpdateAt(auth_obj, type, val){
    console.log('checkWhenUpdateAt');
    const url = settings.API_BASE_URL + 'check_updated_at/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name + '&type='+type +'&val='+val;
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    let when_update = response_obj.obj;
    when_update = when_update.replace('T', ' ')
    return when_update;

  }


  getInventoryList(auth_obj, type, val){
    const url = settings.API_BASE_URL + settings.API_INVENTORY_LIST + '?token=' + auth_obj.token + '&name='+ auth_obj.name + '&type='+type +'&val='+val;
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    return response_obj.list;
  }



  
}

const addHeaderFunction = new FunctionFields();

export { addHeaderFunction };